module.exports = __webpack_public_path__ + "static/img/contant_3.6b03610.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_13/contant_3.jpg
// module id = CmQF
// module chunks = 0